import { InitContainer } from '@/components/shared/InitContainer';
import { useAuth } from '@/contexts/AuthContext';
import { CampaignProvider } from '@/contexts/CampaignContext';
import { TeamProvider } from '@/contexts/TeamContext';
import { Navigate, Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

export const ProtectedRoute = () => {
  const { session, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!session) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <TeamProvider>
      <CampaignProvider>
        <InitContainer>
          <Outlet />
          <Toaster />
        </InitContainer>
      </CampaignProvider>
    </TeamProvider>
  );
};
